module.exports = __webpack_public_path__ + "img/AD.fa4be37d.svg";